import { APIClient } from "./api_helper";
//import * as url from "./url_helper";

const api = new APIClient();

// Post Method
export const postDataAPI = data => api.create(process.env.REACT_APP_API_UR, data);